import React from "react";
import { tWithKeyAttr as t } from "../../../../i18nHelper";
import styles from "../../appointmentsPage.module.css";
import { TRiskLevel, IRiskCounts, IRiskFilters } from "../../types/noShowPredictor.types";

interface IRiskFilterPillsProps {
  counts: IRiskCounts;
  filters: IRiskFilters;
  onFilterChange: (level: TRiskLevel) => void;
}

/**
 * Risk level filter pills with counts
 */
const RiskFilterPills: React.FC<IRiskFilterPillsProps> = ({ 
  counts, 
  filters, 
  onFilterChange 
}) => {
  const pills: { level: TRiskLevel; labelKey: string; className: string }[] = [
    { level: 'high', labelKey: 'NOSHOW_RISK_HIGH', className: styles.high },
    { level: 'medium', labelKey: 'NOSHOW_RISK_MEDIUM', className: styles.medium },
    { level: 'low', labelKey: 'NOSHOW_RISK_LOW', className: styles.low }
  ];

  return (
    <div className={styles.riskPills}>
      {pills.map(pill => (
        <button
          key={pill.level}
          className={`${styles.riskPill} ${pill.className} ${filters[pill.level] ? styles.active : ''}`}
          onClick={() => onFilterChange(pill.level)}
          role="checkbox"
          aria-checked={filters[pill.level]}
        >
          <div className={styles.riskPillLabel}>{t(pill.labelKey)}</div>
          <div className={styles.riskPillCount}>{counts[pill.level]}</div>
        </button>
      ))}
    </div>
  );
};

export default RiskFilterPills;
